import PageBanner from 'components/banners/PageBanner';
import { FeaturesLinks } from 'components/Features';
import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
import styles from './addons.module.scss';

const PROGRAM_DATA = [
  { href: '/client-kiosk', name: 'Client Kiosk/ Portal' },
  { href: '/state-kiosk', name: 'State Kiosk' },
  { href: '/id-card-scanner', name: 'ID Card Scanner' },
  { href: '/custom-survey', name: 'Custom Survey' },
  { href: '/electronic-signature', name: 'Electronic Signature' },
  { href: '/barcode-scanner', name: 'Barcode Scanner' },
  { href: '/campaign-manager', name: 'Campaign Manager' },
  { href: '/auto-dialer', name: 'Auto Dialer &amp; Texter' },
  { href: '/mailing-wizard', name: 'Mailing Wizard' },
];
function AddOns() {
  return (
    <div>
      <Helmet>
        <title>Add ons - CAP60</title>
        <meta
          name="description"
          content="CAP60 is the leading data management solution provider. They offer different data management solutions. Contact us Now!."
        />
        <meta name="keywords" content="programs, cap60 programs" />
      </Helmet>
      <PageBanner
        title="Add ons"
        subtitle="Increase Efficiency & Productivity with CAP60 Tools"
        description="Reduce Administration Costs too!        "
      />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <div className="mt-5">
            <h3>Want to see us in action?</h3>
            <p>
              Helping you serve your clients better. We offer these tools to
              help you do your job better. Not every tool is for every client.
              But for some of you…now that you have them, you can’t do without
              them.
            </p>
          </div>
          <RequestDemoButton />
          <div className={styles.menucontainer}></div>
          <FeaturesLinks
            data={PROGRAM_DATA}
            variant="primary"
            // title="Our Programs"
          />
        </Container>
      </div>
    </div>
  );
}

export default AddOns;
